import { isAfter } from 'date-fns';
import type { Program, ProgramTimelineContentObject } from 'models';
import { Trans } from 'react-i18next';
import { usePermissions } from 'permissions';
import { Loading, Text } from 'ui';
import { ProgramTimelineItem } from '../program-timeline-item';

type P = {
  isLoading: boolean;
  item?: ProgramTimelineContentObject;
  program: Program;
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const TimelineItemContent = ({ isLoading, item, program }: P) => {
  const { canSeeFuturePosts } = usePermissions();

  if (isLoading) {
    return (
      <div>
        <Loading />
      </div>
    );
  }

  if (item && (isAfter(new Date(), item.publishAt) || canSeeFuturePosts({ program }))) {
    return <ProgramTimelineItem data-test-id="program_topic-item" item={item} program={program} />;
  }

  return (
    <Text>
      <Trans>Select some post</Trans>
    </Text>
  );
};

export default TimelineItemContent;
